<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="mb-0" :class="{ 'bg-white p24 rounded12': !this.isMobile }">
            <div>
                <div class="d-flex align-items-center gap8 mb8 fsp14 lh20">
                    <span class="text-black neue-roman">
                        {{ this.$t('views.P2P.SingleSwap.3') }}
                    </span>
                    <span class="require"> *</span>
                </div>
                <InputSimple
                    type="textarea"
                    id="cancel_arbitrage_comment"
                    :dataValue="cancel_arbitrage_comment"
                    :placeholder="this.$t('views.P2P.SingleSwap.49')"
                    :invalid="cancel_arbitrage_comment === '' || cancel_arbitrage_comment?.length > 255"
                    :invalidHint="invalidText"
                    @updateParentState="setValue"
                />
                <div class="neue-roman fsp14 lh20 text-black mt16 mb24">{{ $t('views.P2P.SingleSwap.48') }}</div>
            </div>
            <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button 
                    type="btn-outline-red" 
                    class="equal-width h48 mr16 border-full" 
                    :disabled="!cancel_arbitrage_comment || cancel_arbitrage_comment?.length > 255"
                    @click="this.save()"
                >
                    {{ $t('views.P2P.SingleSwap.44') }}
                </Button>
                <Button 
                    type="btn-outline-grey" 
                    class="equal-width h48 primary-grey" 
                    @click="this.clearAll()"
                >
                    {{ $t('views.P2P.SingleSwap.45') }}
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'
import Select from '@/components/service/Select'
import Input from '@/components/service/Input'
import InputSimple from '@/components/service/InputSimple'

export default {
    name: 'CancelP2PArbitrage',
    components: {
        Icon,
        Button,
        Select,
        Input,
        InputSimple
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            cancel_arbitrage_comment: null,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768
        },
        invalidText() {
            return this.cancel_arbitrage_comment === '' ? this.$t('components.service.GetInputs.5') : 
            this.cancel_arbitrage_comment?.length > 255 && `${this.$t('components.service.GetInputs.1')} 1 ${this.$t('components.service.GetInputs.2')} 255 ${this.$t('components.service.GetInputs.3')}`
        }
    },
    methods: {
        setValue(arg) {
            this[arg.id] = arg.value;
        },
        save() {
            // Проверяем, что комментарий заполнен (обязательное поле)
            if (!this.cancel_arbitrage_comment || this.cancel_arbitrage_comment.trim() === '') {
                // Можно добавить уведомление об ошибке
                return;
            }
            
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback(this.cancel_arbitrage_comment);
            }
            this.close();
        },
        clearAll() {
            this.close();
        }
    }
}
</script>
<style scoped lang="scss">
    textarea.textarea-min-height {
        min-height: 100px;

        &::placeholder {
            color: $primary-grey;
        }
    }
</style>
